import { useEffect, useState } from "react";
import { t } from "i18next";
import Select, { StylesConfig } from 'react-select';
import { getFilteredList, getPageSizeArray, setItemStatus, getValueFromResource } from '../../../../common/timeLiveFunction';
import CustomPagination from "../../../../common/Pagination";
import clsx from "clsx";
import { Dropdown } from 'react-bootstrap';
import Loader from '../../../../common/Loader';
import { ShowToast } from "../../../../common/Toastr";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { KTIcon, useDebounce } from '../../../../_metronic/helpers';
import PageSizeSelect from "../../../../common/PageSizeSelect";
import * as Sentry from "@sentry/react";
import { getAssignedEmployeeProject, checkedAllState, unCheckedAllState, checkedState, unCheckedState, setPageSize, setSearchValue, UpdateSelectedProjects, updateSorting } from "../EmployeeProjectSlice";

const EmployeeProjectList = (props: any) => {
  const { IsProjectEdit, AccountEmployeeId } = props;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { employeeProjectList, isLoading, isReload, pageNo, pageSize, startRec, search, totalItems, recordsFiltered, sortColumn, sortOrder } = useAppSelector((state) => state.employeeProject);
  const [showSelected, setShowSelected] = useState(true);
  const [isFirstTimeLoad, setIsFirstTimeLoad] = useState(true);
  // const [hoveredColumn, setHoveredColumn] = useState(null);

  useEffect(() => {
    // const params = { pageNo: pageNo, pageSize: pageSize, startRec: startRec, columnIndex: columnIndex, direction: direction, search: "", AccountEmployeeId: AccountEmployeeId, IsSelected: showSelected }
    const params = { pageNo: pageNo, pageSize: pageSize, startRec: startRec, search: "", AccountEmployeeId: AccountEmployeeId, IsSelected: showSelected }
    dispatch(getAssignedEmployeeProject(params))
      .unwrap()
      .then((originalPromiseResult) => {
        setIsFirstTimeLoad(false);
      })
      .catch((rejectedValueOrSerializedError) => {
         Sentry.captureException(rejectedValueOrSerializedError);
      })
  }, [isReload, showSelected]);

  const handlePageSizeChange = (event: any) => {
    const { value } = event;
    dispatch(setPageSize(Number(value)));
    // const params = { pageNo: 1, pageSize: value, startRec: 0, columnIndex: columnIndex, direction: direction, search: "", AccountEmployeeId: AccountEmployeeId, IsSelected: showSelected }
    const params = { pageNo: 1, pageSize: value, startRec: 0, search: "", AccountEmployeeId: AccountEmployeeId, IsSelected: showSelected }
    dispatch(getAssignedEmployeeProject(params));
  }

  const handlePageChange = (pageNumber: number) => {
    const start: number = (pageNumber - 1) * pageSize;
    // const params = { pageNo: pageNumber, pageSize: pageSize, startRec: start, columnIndex: columnIndex, direction: direction, search: "", AccountEmployeeId: AccountEmployeeId, IsSelected: showSelected }
    const params = { pageNo: pageNumber, pageSize: pageSize, startRec: start, search: "", AccountEmployeeId: AccountEmployeeId, IsSelected: showSelected }
    dispatch(getAssignedEmployeeProject(params));
  }

  const debouncedSearchTerm = useDebounce(search, 500);
  useEffect(() => {
    if (!isFirstTimeLoad) {
      // const params = { pageNo: 1, pageSize: pageSize, startRec: 0, columnIndex: columnIndex, direction: direction, search: debouncedSearchTerm, AccountEmployeeId: AccountEmployeeId, IsSelected: showSelected }
      const params = { pageNo: 1, pageSize: pageSize, startRec: 0, search: debouncedSearchTerm, AccountEmployeeId: AccountEmployeeId, IsSelected: showSelected }
      dispatch(getAssignedEmployeeProject(params));
    }
  }, [debouncedSearchTerm]);

  const handleSearch = (event: any) => {
    const { value } = event.target;
    dispatch(setSearchValue(value))
  }

  const handleSelectAllChange = (e: any) => {
    const { checked } = e.target;
    if (checked) {
      dispatch(checkedAllState());
    } else {
      dispatch(unCheckedAllState());
    }
  }

  const handleCheckboxChange = (e: any, AccountEmployeeProjectId: any, AccountProjectId: any) => {
    if (e.target.checked) {
      dispatch(checkedState({ AccountEmployeeProjectId, AccountProjectId }))
    } else {
      dispatch(unCheckedState({ AccountEmployeeProjectId, AccountProjectId }))
    }
  }

  const onUpdateSelectedRecords = () => {
    dispatch(UpdateSelectedProjects({ AccountEmployeeId: AccountEmployeeId, List: employeeProjectList, IsSelected: showSelected }))
      .unwrap()
      .then((originalPromiseResult) => {
        originalPromiseResult.StatusCode === "200" ?
          ShowToast('success', 'Record Updated Successfully!', "success", "toast-top-right") :
          ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
      })
      .catch((rejectedValueOrSerializedError) => {
         Sentry.captureException(rejectedValueOrSerializedError);
      })
  }

  const onHandleShowSelected = (e: any) => {
    const { checked } = e.target;
    setShowSelected(checked);
  }

  const navigateToProjectSummary = (obj: any) => {
    localStorage.setItem('objProject', JSON.stringify(obj));
    navigate(`/accountprojectsummary/${obj.AccountProjectId}`);
  }

  const determineDueStatus = (deadline: any, startDate: any) => {
    const now = new Date();
    let status: string = "Soon Due"
    if (deadline) {
      const deadlineDate = new Date(deadline);
      if (now > deadlineDate) {
        status = 'Overdue';
      } else if (now.getDate() === deadlineDate.getDate()) {
        status = 'Due';
      } else if (now < deadlineDate) {
        status = 'Soon Due';
      }
    } else if (startDate && now < new Date(startDate)) {
      status = 'Start Soon';
    }
    return status;
  }

  const onHandleSorting = (sortOrder: string, sortColumn: string) => {
    let objects = {
      "sortOrder": sortOrder,
      "sortColumn": sortColumn,
      "start": 0,
      "pageSize": pageSize,
      "currentPage": 1
    }
    dispatch(updateSorting(objects));
    // dispatch(getEmployeesList({ currentPage: 1, pageSize: 10, start: 0, search: " " }));
    const params = { pageNo: 1, pageSize: pageSize, startRec: 0, search: " ", AccountEmployeeId: AccountEmployeeId, IsSelected: showSelected }
    dispatch(getAssignedEmployeeProject(params));
  }

  // const handleMouseEnter = (columnIndex: any) => {
  //   setHoveredColumn(columnIndex);
  // }

  // const handleMouseLeave = () => {
  //   setHoveredColumn(null);
  // }

  return (
    <>
      {isLoading && <Loader />}
      <div className="card card-custom admin-card">
        <div className="card-header card-drop sticky-top bg-white fixed-top">
          <h3 className="card-title fw-bold headerTitle">
            {/* {t('Project List')} */}
            {getValueFromResource('Project List', dispatch, t)}
          </h3>
          <div className="card-toolbar align-items-center">
            {IsProjectEdit &&
              <>
                <span className="me-2 text-muted" data-kt-user-table-select="selected_count">
                  {/* {t('Show Selected Projects:')} */}
                  {getValueFromResource('Show Assigned Projects:', dispatch, t)}
                </span>
                <div className="form-check form-switch form-check-custom">
                  <input
                    type="checkbox"
                    className="form-check-input custom-padding-right h-15px w-30px"
                    checked={showSelected}
                    onChange={(e) => { onHandleShowSelected(e) }}
                  />
                </div>
                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
              </>
            }
            <div className="position-relative">
              <input
                type="text"
                value={search}
                onChange={handleSearch}
                placeholder=
                // {t('Search')}
                {getValueFromResource('Search', dispatch, t)}
                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                data-kt-user-table-filter="search"
              />
              <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0 searchIconRight">
                <span className="path1"></span>
                <span className="path2"></span>
              </i>
            </div>
            <div className='h-35px w-1px mx-1'></div>
            <div className="d-flex align-items-center">
              {/* <Select
                styles={colourStyles}
                options={getPageSizeArray()}
                value={getPageSizeArray().find((option: any) => option.value == pageSize)}
                onChange={handlePageSizeChange}
                className='fs-7 fw-normal'
              /> */}
              <PageSizeSelect onChange={handlePageSizeChange} />

            </div>
            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
            <div>
              {(employeeProjectList.length > 0) ? (
                <CustomPagination
                  currentPage={pageNo}
                  onPageChange={handlePageChange}
                  pageSize={pageSize}
                  totalItems={totalItems}
                  start={(pageNo - 1) * pageSize}
                  t={t}
                  recordsFiltered={recordsFiltered}
                >
                </CustomPagination>
              ) : null}
            </div>
            <>
              <div className='bullet bg-secondary h-35px w-1px mx-3' style={{ display: employeeProjectList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}></div>
              <div className="text-muted me-5" style={{ marginRight: '2px', display: employeeProjectList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                <span className="me-2" data-kt-user-table-select="selected_count">{employeeProjectList.filter((item: any) => item.isSelected === 1).length}</span>
                {/* {t('Selected')} */}
                {getValueFromResource('Selected', dispatch, t)}
              </div>
              <button type="button" className="btn btn-primary btn-bs-btn-font-weight btn-sm "
                onClick={() => { onUpdateSelectedRecords() }}
                style={{ marginRight: '2px', display: employeeProjectList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
              >
                {/* {t('Update')} */}
                {getValueFromResource('Update', dispatch, t)}
              </button>
            </>
          </div>
        </div>
        {/* <div className='card-body py-3'> */}
        <div className="card-Report-body py-3">
          <div className='table-responsive'>
            <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' style={{ width: '100%' }}>
              <thead>
                <tr className='thHeading align-middle'>
                  <th className='w-25px'>
                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        checked={employeeProjectList.every((item: any) => item.isSelected === 0) ? false :
                          (employeeProjectList.every((item: any) => item.isSelected === 1 ? true : false))
                        }
                        onChange={handleSelectAllChange}
                      />
                    </div>
                  </th>
                  <th className='w-25px'>
                    {sortColumn === '1' ?
                      sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "1") }}>
                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                      </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "1") }}>
                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                      </span>
                      : <><span className="cursor" onClick={() => { onHandleSorting("asc", "1") }}>
                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                      </span>
                        <span className="cursor" onClick={() => { onHandleSorting("desc", "1") }}>
                          <i className="bi bi-sort-down fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                      </>}
                  </th>
                  <th className='w-25px'>
                    {sortColumn === '2' ?
                      sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "2") }}>
                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                      </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "2") }}>
                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                      </span>
                      : <><span className="cursor" onClick={() => { onHandleSorting("asc", "2") }}>
                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                      </span>
                        <span className="cursor" onClick={() => { onHandleSorting("desc", "2") }}>
                          <i className="bi bi-sort-down fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                      </>}
                  </th>
                  <th style={{ width: '40%' }}
                  // onMouseEnter={() => handleMouseEnter(2)}
                  // onMouseLeave={handleMouseLeave}
                  >
                    {/* {t("Project Name")} */}
                    {getValueFromResource('Project Name', dispatch, t)}
                    {sortColumn === '4' ?
                      sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "4") }}>
                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                      </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "4") }}>
                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                      </span>
                      :
                      // hoveredColumn === 2 && 
                      <><span className="cursor" onClick={() => { onHandleSorting("asc", "4") }}>
                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                      </span>
                        <span className="cursor" onClick={() => { onHandleSorting("desc", "4") }}>
                          <i className="bi bi-sort-down fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                      </>}
                  </th>
                  <th style={{ width: '40%' }}
                  // onMouseEnter={() => handleMouseEnter(1)}
                  // onMouseLeave={handleMouseLeave}
                  >
                    {/* {t("Client Name")} */}
                    {getValueFromResource('Client Name', dispatch, t)}
                    {sortColumn === '3' ?
                      sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "3") }}>
                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                      </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "3") }}>
                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                      </span>
                      :
                      // hoveredColumn === 1 && 
                      <><span className="cursor" onClick={() => { onHandleSorting("asc", "3") }}>
                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                      </span>
                        <span className="cursor" onClick={() => { onHandleSorting("desc", "3") }}>
                          <i className="bi bi-sort-down fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                      </>}
                  </th>
                  <th style={{ width: '10%' }}
                  // onMouseEnter={() => handleMouseEnter(4)}
                  // onMouseLeave={handleMouseLeave}
                  >
                    {/* {t("Status")} */}
                    {getValueFromResource('Status', dispatch, t)}
                    {sortColumn === '6' ?
                      sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "6") }}>
                        <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                      </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "6") }}>
                        <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                      </span>
                      :
                      // hoveredColumn === 4 && 
                      <><span className="cursor" onClick={() => { onHandleSorting("asc", "6") }}>
                        <i className="bi bi-sort-up fs-6 headerSortIcon">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                      </span>
                        <span className="cursor" onClick={() => { onHandleSorting("desc", "6") }}>
                          <i className="bi bi-sort-down fs-6 headerSortIcon">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                        </span>
                      </>}
                  </th>
                </tr>
              </thead>
              <tbody>
                {employeeProjectList.length > 0 && employeeProjectList.map((item: any) => {
                  return (
                    <tr key={`${item.AccountProjectEmployeeId}-${item.ssnnoo}`}>
                      <td>
                        <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                          <input
                            className='form-check-input widget-9-check'
                            type='checkbox'
                            checked={item.isSelected == 0 ? false : true}
                            onChange={(e) => { handleCheckboxChange(e, (item.AccountProjectEmployeeId ? item.AccountProjectEmployeeId : item.AccountEmployeeId), item.AccountProjectId) }}
                          />
                        </div>
                      </td>
                      <td>
                        <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(item.IsDisabled === false ? "Active" : "InActive"))}>
                          {item.IsDisabled === false ? "Active" : "InActive"}
                        </span>
                      </td>
                      <td>
                        <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(determineDueStatus(item.Deadline, item.StartDate)))}>
                          {determineDueStatus(item.Deadline, item.StartDate)}
                        </span>
                      </td>
                      <td>
                        <a className='text-dark fw-bold d-block cursor'
                          onClick={() => {
                            navigateToProjectSummary({
                              "AccountProjectId": item.AccountProjectId,
                              "AccountProjectTaskId": item.AccountProjectTaskId,
                              "ProjectCode": item.ProjectCode,
                              "ProjectName": item.ProjectName,
                              "Status": item.Status,
                              "StartDate": item.StartDate,
                              "Deadline": item.Deadline,
                              "ProjectBillingRateTypeId": item.ProjectBillingRateTypeId,
                              "IsSummaryFrom": 'View',
                              "IsTask": true,
                              "IsMilestone": true,
                              "IsProjectTeam": true
                            });
                          }}
                        >
                          {item.ProjectName}
                        </a>
                      </td>
                      <td>
                        <span className="d-block">{item.ClientName}</span>
                      </td>
                      <td>
                        <span className={`badge fs-7 ${setItemStatus(item.Status)}`}>{item.Status}</span>
                      </td>
                      <td className='text-center'>
                        <Dropdown
                          style={{ marginLeft: 1 }}
                          className={clsx('cursor-pointer symbol')}
                          data-kt-menu-attach='parent'
                          data-kt-menu-placement='bottom-end'
                        >
                          <Dropdown.Toggle
                            variant="transparent"
                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                            data-tooltip-id="tooltip-Description"
                            data-tooltip-content=
                            // {t("More")}
                            {getValueFromResource('More', dispatch, t)}
                            data-tooltip-place="top"
                          >
                            <i className="bi bi-three-dots fs-7"></i>
                          </Dropdown.Toggle>
                          <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                            <div className='menu-hover-bg-sec'>
                              <Dropdown.Item
                                className="menu-item me-lg-0"
                                onClick={() => {
                                  navigateToProjectSummary({
                                    "AccountProjectId": item.AccountProjectId,
                                    "AccountProjectTaskId": item.AccountProjectTaskId,
                                    "ProjectCode": item.ProjectCode,
                                    "ProjectName": item.ProjectName,
                                    "Status": item.Status,
                                    "StartDate": item.StartDate,
                                    "Deadline": item.Deadline,
                                    "ProjectBillingRateTypeId": item.ProjectBillingRateTypeId,
                                    "IsSummaryFrom": 'View',
                                    "IsTask": true,
                                    "IsMilestone": true,
                                    "IsProjectTeam": true
                                  });
                                }}
                              >
                                <span className="menu-icon custom-menu mb-2">
                                  <i className="bi bi-box-arrow-up-right fs-6 iconColor">
                                    <span className="path1"></span>
                                    <span className="path2"></span>
                                  </i>
                                  {/* <i className="bi bi-file-earmark-text fs-4 iconColor">
                                    <span className="path1"></span>
                                    <span className="path2"></span>
                                  </i> */}
                                </span>
                                <span className="menu-title custom-menu-fontsize">
                                  {/* {`${t('View Project')}`} */}
                                  {getValueFromResource('View Project', dispatch, t)}
                                </span>
                              </Dropdown.Item>
                            </div>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
            {employeeProjectList.length === 0 &&
              <div className=''>
                <p className='noDataFound'>
                  {/* {t('No Record Found')} */}

                  {getValueFromResource('No Record Found', dispatch, t)}
                </p>
              </div>
            }
          </div>
        </div>
      </div>
    </>
  )
}

export default EmployeeProjectList

const colourStyles: StylesConfig = {
  control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}